import { PrismicDocument } from '@prismicio/types';
import clsx from 'clsx';
import { BlogCard } from 'src/features/blog/components/card/card';
import styles from './blog-post-carousel-slide.module.css';

type Props = {
  blogPostSlides: PrismicDocument[][];
};

export function BlogPostCarouselSlide({ blogPostSlides }: Props) {
  return (
    <>
      {blogPostSlides.map((blogPostSlide, index) => {
        return (
          <div className="flex min-w-full justify-center" key={index}>
            {blogPostSlide.map((blogPost) => {
              return (
                <div
                  className={clsx(
                    'mr-lg px-2xs relative flex w-full shrink-0 flex-col items-stretch last:mr-0 md:items-center md:px-0',
                    styles.slide,
                  )}
                  key={blogPost.id}
                >
                  <BlogCard post={blogPost} variant="carousel" />
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
}
